// extracted by mini-css-extract-plugin
module.exports = {"noop":"ReferenceInformation_noop__2Nl2H","referenceInformationTable":"ReferenceInformation_referenceInformationTable__1RtBR"};